module.exports = __webpack_public_path__ + "static/media/bold.02d81fdb.png";